import { render } from "./RankingLastYear.vue?vue&type=template&id=4d16ef71"
import script from "./RankingLastYear.vue?vue&type=script&lang=js"
export * from "./RankingLastYear.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__